import { render, staticRenderFns } from "./MyTabs.vue?vue&type=template&id=2c392368&scoped=true&"
import script from "./MyTabs.vue?vue&type=script&lang=js&"
export * from "./MyTabs.vue?vue&type=script&lang=js&"
import style0 from "./MyTabs.vue?vue&type=style&index=0&id=2c392368&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c392368",
  null
  
)

export default component.exports